import script from "./entouragePersonInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./entouragePersonInput.vue?vue&type=script&setup=true&lang=ts"

import "./entouragePersonInput.vue?vue&type=style&index=0&id=2bdb3090&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bdb3090"]])

export default __exports__